import { Filler } from "ds/components/DatePickerInputField/lazy";
import { inputWidth, VERY_SMALL } from "ds/materials/metrics";
import lazy from "dsl/atoms/retry";
import { Suspense } from "react";
import { TimePickerProps } from "./input";

const LazyDate = lazy(() => import("./input"));

export default function LazyPicker(props: TimePickerProps) {
  const width = props?.width || inputWidth(props?.inputWidthType || VERY_SMALL);
  return (
    <Suspense
      fallback={
        <Filler width={width} label={props?.label} required={props?.required} />
      }
    >
      <LazyDate {...props} />
    </Suspense>
  );
}
